import { MenuItem, styled, Typography } from '@mui/material';
import { CONTACT_PROCTORFREE_SUCCESS_TEAM_BASE_URL } from '@shared';
import { useSession } from 'App';

const DisappearingButton = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down(924)]: {
    display: 'none',
  },
  [theme.breakpoints.up(924)]: {
    display: 'flex',
    marginLeft: 24,
  },
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.black.main,
  },
}));

type PropsType = {
  isMenu?: boolean;
};

export const ContactProctorFreeButton = ({ isMenu }: PropsType) => {
  const { currentUser } = useSession();
  const isInstructor = currentUser && currentUser.roles && currentUser.roles.isInstructor;

  if (!isInstructor) {
    return null;
  }

  const handleContact = () => {
    const originatingUrl = window.location.href;

    const finalUrl = `${CONTACT_PROCTORFREE_SUCCESS_TEAM_BASE_URL}?audit_url=${encodeURIComponent(
      originatingUrl
    )}`;

    window.open(finalUrl, '_blank', 'noopener,noreferrer');
  };

  const title = 'Contact ProctorFree';

  return isMenu ? (
    <MenuItem key={title} sx={{ minHeight: 40 }} onClick={handleContact}>
      <Typography variant='navLink'>{title}</Typography>
    </MenuItem>
  ) : (
    <DisappearingButton onClick={handleContact} variant='navLink'>
      {title}
    </DisappearingButton>
  );
};
